import type { Except, ServerWithTest } from '@festina-life/core'
import { FormikSelect } from '@festina-life/ui/formikForms'
import type { ComponentProps } from 'react'

import { useFetchOperationsEnums } from '../../hooks/useFetchOperationsEnums'

type Props<T> = Except<ComponentProps<typeof FormikSelect<T>>, 'options'> & {
  component: ServerWithTest
  enumType: string
}

// Currently made for the use case of fetching enums for the operations
// It is used in combination with the create-formikfields-from-openapi script.
// Should be possible to delete this in the future with some changes to the script
export const GenericFormikSelect = <T,>({
  component,
  enumType,
  ...rest
}: Props<T>) => {
  const { data } = useFetchOperationsEnums({ component, enumType })

  const options = data?.literals?.map((x) => x?.name) as T[]

  return <FormikSelect options={options} {...rest} />
}
